<template>
  <div class="container">
    <div class="title">扫码关注优学派官方平台公众号，领取新人超值大礼包</div>
    <Qrcode class="qrcode" :src="adviser.officialWechatImg" :tracker="tracker" :meta="meta" />
    <div class="hint">长按识别二维码，关注{{adviser.name}}</div>
  </div>
</template>
<script>
import { PAGE_EXPOSE } from "../../../utils/bigDataSdk";
import Qrcode from '../../../components/Qrcode.vue'

const pageInfo = {
  pageId: "40005",
  pageName: "公众号二维码页",
  pageTilte: "报名成功",
};
export default {
  props: {
    tracker: Function,
  },
  components:{
    Qrcode
  },
  mounted() {
    setTimeout(() => {
      this.tracker({
        eventKey: PAGE_EXPOSE,
        ...pageInfo,
      });
    }, 0);
  },
  computed: {
    adviser() {
      console.log(this.$store.state.activity.config);
      return this.$store.state.activity.config || {};
    },
    meta(){
      return  {
        buttonName: '二维码长按',
        buttonContent: '二维码长按'
      };
    }
  },
   
};
</script>
<style lang="scss" scoped>
.container {
  text-align: center;
}
.title {
  margin-top: 120px;
  font-size: 14px;
  font-weight: blod;
  color: #34404a;
  line-height: 19px;
}
.qrcode {
  margin-top: 25px;
  width: 150px;
  height: 150px;
}

.hint {
  margin-top: 20px;
  font-size: 13px;
  font-weight: 500;
  color: #999999;
}
</style>
